import './errorStyle.css';

const PageNotFound = () => {

  return (
    <div className={"errorContainer"}>
      <div className={"textContainer"}>
      <span className={"errorHeading"}>
      Page not found
        </span>
        <span className={"errorText"}>
        Uh oh, We can’t locate the page you’re looking for, the page has been moved or deleted.
        </span>
      </div>
    </div>
  )
};

export default PageNotFound;
